/*
 * File: Tag.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 28, 2025 at 2:18 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled, { css } from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	${({ $size }) => ($size === 'normal' ? css`
		padding: 8px 18px;
	` : css`
		padding: 4px 12px;
	`)}
	gap: 8px;
	background-color: ${({ theme }) => theme.surfaceBackground};
	color: ${({ theme }) => theme.primarySurfaceText};
	border-radius: 20px;
	border: none;
	cursor: pointer;
	box-shadow: ${({ theme }) => theme.surfaceShadow};
	background-color: ${({ theme }) => theme.surfaceBackground};
	color: ${({ theme }) => theme.primarySurfaceText};

	&.active {
		background-color: ${({ theme }) => theme.primaryDecoration};
		color: ${({ theme }) => theme.white};
	}
`;
